const OverviewPage = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-white">Overview</h1>
      <p className="text-gray-400 mt-2">Dashboard overview content</p>
    </div>
  );
};
export default OverviewPage;